import {createSlice} from '@reduxjs/toolkit';
import {navigateToBackendLogin, navigateToLogin} from "../utils/navigator";
import {getUserType, removeAgentId, removeTenantId, removeToken, setTenantId, setUserType} from "../utils/user";

const initialState = {
    userInfo : null,
};

export const userSlice = createSlice({
    name: 'user',
    initialState,
    reducers: {
        userInit: (state, action) => {
            let userType = action.payload.type;
            setUserType(userType)
            if(userType !== "USER"){
               window.localStorage.setItem("lang", "zh");
               if(userType === "AGENT"){
                  document.title = "管理平台"
               }else if(userType === "ADMIN"){
                  document.title = "系统平台"
               }
            }
            if(action.payload.tenantId){
               setTenantId(action.payload.tenantId)
            }
            state.userInfo = action.payload;
        },
        userLogout : (state) => {
            removeToken();
            removeTenantId();
            removeAgentId();
            let userType = getUserType();
            if(userType === 3){
               navigateToLogin()
            }else{
               navigateToBackendLogin()
            }
        },
        userUpdate : (state, action) => {
            let { payload } = action;
            if(state.userInfo){
               state.userInfo = {...state.userInfo, ...payload}
            }
        }
    }
});

export const { userInit, userLogout, userUpdate } = userSlice.actions;

export const selectUserInfo = (state) => {
    if(!state.user){
        return undefined;
    }
    let userInfo = {...state.user.userInfo};
    return userInfo?.id ? userInfo : undefined;
}



export default userSlice.reducer;
